import { ApiFormattedResponse } from "@models/api_formatted_response"
import { mutate, query } from "@utils/graphql"
import {
  CouponCodesResponse,
  CreateCouponCodeInput,
  CustomerPerson,
  DeleteCouponCodeInput,
  GetCustomerOwnersResponse,
  MutationOneTimesUpdateMutationArgs,
  OCouponCodeResponse,
  OPlatformResponse
} from "__generated__/graphql"
import createCouponCode from "__generated__/queries/mutations/createCouponCode"

import deleteCouponCode from "__generated__/queries/mutations/deleteCouponCode"
import oneTimesUpdateMutation from "__generated__/queries/mutations/oneTimesUpdateMutation"
import couponCodes from "__generated__/queries/queries/couponCodes"
import getCustomerOwners from "__generated__/queries/queries/getCustomerOwners"

export async function getCoupons(data: {
  search?: string
  limit: number
  page: number
}): Promise<ApiFormattedResponse<CouponCodesResponse>> {
  const response = await query<{
    couponCodes?: CouponCodesResponse
  }>({
    query: couponCodes,
    variables: { args: data }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.couponCodes?.data }
  }
}
export async function getCustomers(data: {
  search?: string
  pageNumber: number
  pageSize: number
}): Promise<{
  isSuccess: boolean
  data: CustomerPerson[] | null
}> {
  const response = await query<{
    getCustomerOwners?: GetCustomerOwnersResponse
  }>({
    query: getCustomerOwners,
    fetchPolicy: "network-only",
    variables: {
      ...(data.search && { search: data.search }),
      pageNumber: data.pageNumber,
      pageSize: data.pageSize
    }
  })
  if (!response.isSuccess) {
    return { ...response, data: null }
  }
  const newPerson = response?.data?.getCustomerOwners?.data.docs.map((p) => ({
    ...p.customerPerson
  }))
  return {
    isSuccess: true,
    data: newPerson as CustomerPerson[]
  }
}

export async function createCoupons(
  data: CreateCouponCodeInput
): Promise<ApiFormattedResponse<CouponCodesResponse>> {
  const response = await mutate<{
    createCouponCode?: CouponCodesResponse
  }>({
    mutation: createCouponCode,
    variables: { data: data }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.createCouponCode?.data }
  }
}

export async function oneTimesUpdate(
  data: MutationOneTimesUpdateMutationArgs
): Promise<ApiFormattedResponse<OPlatformResponse>> {
  const response = await mutate<{
    oneTimesUpdateMutation?: OPlatformResponse
  }>({
    mutation: oneTimesUpdateMutation,
    variables: { type: data.type, metaData: data.metaData }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }

  return {
    isSuccess: true,
    data: { data: response?.data?.oneTimesUpdateMutation?.data }
  }
}

export async function deleteCoupons(
  data: DeleteCouponCodeInput
): Promise<ApiFormattedResponse<OCouponCodeResponse>> {
  const response = await mutate<{
    deleteCouponCode?: OCouponCodeResponse
  }>({
    mutation: deleteCouponCode,
    variables: { data: { _id: data._id } }
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }
  return {
    isSuccess: true,
    data: { data: response?.data?.deleteCouponCode?.data }
  }
}
